import * as tPromise from "io-ts-promise";
import {
  CostCategory,
  costCategoriesT,
  costCategoryT,
  CostRule,
  costRulesT,
  costRuleT,
  CostRuleInput,
  InsightProductOption,
  insightProductOptionsT,
  ManualCost,
  manualCostsT,
  manualCostT,
  ManualCostInput,
  ManualDimension,
  RateType,
  RuleDimension,
} from "dora-contracts";
import axios, { getData } from "../../axios";

export type {
  CostCategory,
  CostRule,
  ManualCost,
  ManualDimension,
  RateType,
  RuleDimension,
  InsightProductOption as ProductOption,
};

export const listProducts = () =>
  axios
    .get("/api/insights/products")
    .then(getData)
    .then(tPromise.decode(insightProductOptionsT));

const base = "/api/insight-costs";

// categories
export const listCategories = () =>
  axios.get(`${base}/categories`).then(getData).then(tPromise.decode(costCategoriesT));
export const createCategory = (input: { name: string }) =>
  axios.post(`${base}/categories`, input).then(getData).then(tPromise.decode(costCategoryT));
export const updateCategory = (id: string, input: { name: string }) =>
  axios.put(`${base}/categories/${id}`, input);
export const deleteCategory = (id: string) =>
  axios.delete(`${base}/categories/${id}`);

// rules
export const listRules = () =>
  axios.get(`${base}/rules`).then(getData).then(tPromise.decode(costRulesT));
export const createRule = (input: CostRuleInput) =>
  axios.post(`${base}/rules`, input).then(getData).then(tPromise.decode(costRuleT));
export const updateRule = (id: string, input: CostRuleInput) =>
  axios.put(`${base}/rules/${id}`, input);
export const deleteRule = (id: string) => axios.delete(`${base}/rules/${id}`);

// manual costs
export const listManualCosts = () =>
  axios.get(`${base}/manual-costs`).then(getData).then(tPromise.decode(manualCostsT));
export const createManualCost = (input: ManualCostInput) =>
  axios
    .post(`${base}/manual-costs`, input)
    .then(getData)
    .then(tPromise.decode(manualCostT));
export const updateManualCost = (id: string, input: ManualCostInput) =>
  axios.put(`${base}/manual-costs/${id}`, input);
export const deleteManualCost = (id: string) =>
  axios.delete(`${base}/manual-costs/${id}`);
